module.exports = __webpack_public_path__ + "assets/filter-free-delivery-je-8e724e.svg";